import React, { useState, useEffect, useRef } from 'react';
import { PostDataAPI } from './services/PostDataAPI'; // Your API service

import Header from './components/header';
import Footer from './components/footer';
import { Grid, Typography, Avatar, Button, Box } from '@mui/material';
import Lottie from "lottie-react";
import MainScene from "./assets/img/MainScene.json";
import SEOTags from './common/SEO';

const Videos = () => {
    const [listVideos, setListVideos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [page, setPage] = useState(1); // Track the current page
    const [hasMore, setHasMore] = useState(true); // Flag to track if more data is available
    const initialLoad = useRef(true); // To track the first render
    const pageSize = 6;

  

    // Fetch video data with pagination
    const fetchVideos = async () => {
        setLoading(true);
        try {
            const result = await PostDataAPI("video/getAllVideos", { page, pageSize }); // Passing page and pageSize
            if (result.success && result.data) {
                setListVideos(prevVideos => [...prevVideos, ...result.data]); // Append new videos
                if (result.data.length < pageSize) {
                    setHasMore(false); // Stop further API calls if the data length is less than pageSize
                }
            } else {
                setError(result.message || "No videos available.");
            }
        } catch (error) {
            if (error.name !== 'AbortError') {
                setError("Failed to fetch videos: " + error.message);
            }
        } finally {
            setLoading(false);
        }
    };
    const formatSubscriberCount = (count) => {
        let formattedCount;

        if (count >= 1000000) {
            formattedCount = (count / 1000000).toFixed(2) + 'M'; // Shows two decimal places for millions
        } else if (count >= 1000) {
            formattedCount = (count / 1000).toFixed(2) + 'K'; // Shows two decimal places for thousands
        } else {
            formattedCount = count.toString(); // If it's less than 1000, just return the number
        }

        // Return formatted count with singular/plural for "subscriber"
        if (count === 1) {
            return `${formattedCount} subscriber`; // Singular for 1
        } else {
            return `${formattedCount} subscribers`; // Plural for all other counts
        }
    };
    // Handle scroll event for infinite scroll
    const handleScroll = () => {
        const bottom = window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 50; // 50px buffer
        if (bottom && !loading && hasMore) {
            setPage(prevPage => prevPage + 1); // Increment page number only if there's more data
        }
    };

    useEffect(() => {
        //if (initialLoad.current) {
        //    initialLoad.current = false; // Mark initial render as handled
        //    return;
        //}
        fetchVideos(); // Fetch data when page changes
    }, [page]);

    useEffect(() => {
        SEOTags(
            "Videos | Freddie Figgers",
            "Watch exclusive videos of Freddie Figgers' events, achievements, and inspiring initiatives that highlight his contributions to technology and community.",
            "Videos, Freddie Figgers"
        );
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [loading]);

    return (
        <>
          
            <Header />

            <h2 className="page_heading">FREDDIE FIGGERS VLOG</h2>
            <p className="page_subheading">Freddie Figgers is an American Inventor, Software Engineer and Philanthropist.</p>
            <div className="layout_container">
                <Grid container className={'video-container'}>
                    {listVideos.map((video) => (
                        <Grid className='vlog_content' item xs={12} sm={12} md={4} lg={4} key={video.videoId} style={{padding: '0px 15px'}}>
                            <Box mb={2}>
                                <iframe
                                    width="100%"
                                    height="250"
                                    src={`https://www.youtube.com/embed/${video.videoId}?autoplay=1&mute=1&controls=0&autohide=1&rel=0`}
                                    title={video.title}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    allowFullScreen
                                ></iframe>
                            </Box>
                            <Typography variant="h6" component="h3" mb={1}>
                                <a href={video.videoUrl} target='_blank'> {video.title}</a>
                            </Typography>

                            {/* Channel Profile */}
                            <Box display="flex" alignItems="center" mb={2}>
                                <Avatar
                                    src={video.channelDP}
                                    alt={video.channelTitle}
                                    sx={{ width: 40, height: 40, mr: 2 }}
                                />
                                <div>
                                    <Typography variant="body2">{video.channelTitle}</Typography>
                                    <Typography style={{ color: '#999999', fontSize: '15px' }}>{formatSubscriberCount(video.subscriberCount)}</Typography>
                                </div>

                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </div>



            {error && <p>{error}</p>}
            {loading && <div className={'no_post_text'} style={{ width: '100%', height: '40px' }}>
                <Lottie
                    animationData={MainScene}
                    loop={true}
                    style={{
                        width: '100%',
                        height: '100%',
                    }}
                />
            </div>}
            {!hasMore && !loading && <p className={'no_post_text'}>No more videos to show.</p>}

            <Footer />
        </>
    );
};

export default Videos;
